import bModal from './modal.vue';

export default bModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/components/modal/modal.js
// module id = 329
// module chunks = 0